<template>
  <div class="did-floating-label-content">
    <select class="did-floating-select" onclick="this.setAttribute('value', this.value);"  @change="updateValue($event.target.value)">
      <option v-for="item in options" :key="item.id" :value="item.label"> <img class="mr-2" style="border-radius: 10px; max-width: 20px" :src="`/img/banks/tdbbank.png`">{{ item.label }}</option>
    </select>
    <label class="did-floating-label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'CustomTextDropdown',
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      inputValue: '',
      isActive: false
    };
  },
  methods: {
    checkInput() {
      this.isActive = this.inputValue !== '';
    },
    updateValue(value) {
      this.$emit('input', value); // Emit the input event to update the v-model
    }
  }
};
</script>

<style scoped>

.did-floating-label-content {
  position:relative;
  margin-bottom:20px;
}
.did-floating-label {
  color: var(--gray-color-new);
  font-size:14px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:15px;
  top:15px;
  padding:0 5px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
.did-floating-select {
  font-size:14px;
  display:block;
  width:100%;
  height:54px;
  padding: 0 20px;
  background: var(--gray-color-10-new);
  color: var(--primary-color-new);
  border-radius: 6px;
  box-sizing: border-box;
  border: none;
  text-decoration: none;
  outline: none;
  &:focus{
    outline:none;
    padding-top: 12px;
    ~ .did-floating-label{
      top:7px;
      font-size:11px;
    }
  }
}

select.did-floating-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
select.did-floating-select::-ms-expand {
  display: none;
}

.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top:7px;
  font-size:11px;
}
.did-floating-select[value=""]:focus ~ .did-floating-label {
  top:15px;
  font-size:14px;
}

.did-floating-select:not(:placeholder-shown) {
  padding-top: 12px;
}

.did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}

.did-error-input{
  .did-floating-input, .did-floating-select {
    border: 2px solid #9d3b3b;
    color:#9d3b3b;
  }
  .did-floating-label{
    font-weight: 600;
    color:#9d3b3b;
  }
  .did-floating-select:not([multiple]):not([size]) {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%239d3b3b'/%3E%3C/svg%3E%0A");
  }
}
</style>
